import React from 'react';
import PropTypes from 'prop-types';

import Indicator from 'v-c/LoadingIndicator/Indicator';

import styles from './ContentHeader.scss';

function ContentTitle({ text, counter, children, linkText, isLoading }) {
    return (<h1 className={`${styles['content-title']} content-title`}>
        {text}
        {counter && !counter.total && (
            <span className={styles['content-title-counter']}>
                {`(${counter.index})`}
            </span>
        )}
        {counter && counter.total && (
            <span className={styles['content-title-counter']}>
                {`(${counter.index} of ${counter.total})`}
            </span>
        )}
        {!!linkText && (
            <span className={styles['content-title-link']} role="presentation" onClick={linkText.onClick}>
                {linkText.text}
            </span>
        )}
        {children}
        {isLoading && <Indicator />}
    </h1>)
}

ContentTitle.propTypes = {
    text: PropTypes.any.isRequired,
    counter: PropTypes.shape({
        index: PropTypes.any.isRequired,
        total: PropTypes.number,
    }),
    linkText: PropTypes.shape({
        text: PropTypes.any.isRequired,
        onClick: PropTypes.func.isRequired,
    }),
    children: PropTypes.any,
    isLoading: PropTypes.bool,
};

ContentTitle.defaultProps = {
    children: null,
    counter: null,
    linkText: null,
    isLoading: false,
};

export default ContentTitle;
